import global from '../../intl/fr'

const messages = {
  global,
}

export default messages
